import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { ModalShareConfigurationPersonalizeOfferStyled } from '../../ModalShareConfigurationPersonalizeOfferStyled';
import { rem } from 'polished';

export const ModalShareConfigurationDealerCodeStyledOVGB = styled(ModalShareConfigurationPersonalizeOfferStyled)`
    .share-wrapper {
        .submit {
            @media (min-width: ${breakpoints.md}px) {
                width: 70%;
            }
        }

        .input-wrapper {
            .dropdown,
            input {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }

            .input-section-label {
                font-size: ${rem(16)};
            }
        }

        .mandatory {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }

    .checkboxSection {
        &-title p {
            font-size: ${rem(16)};
        }

        .container label {
            font-size: ${rem(16)};
        }
    }
`;
